import { Flex, Spinner, Text } from '@/src/ui-components';

export const PathFindingPending = () => {
  return (
    <Flex
      align="center"
      gap={2}
      className="mb-4 rounded-lg border border-blue-200 bg-blue-50 p-3 dark:border-blue-800 dark:bg-blue-900/20"
    >
      <Spinner />
      <Text as="span" size="sm" className="text-blue-800 dark:text-blue-200">
        Finding payment path...
      </Text>
    </Flex>
  );
};
